// The backend settles a pending e-mail outcome at the latest one hour after the operation finished.
export const FINANCING_ENDING_DELIVERY_RESULT_DEADLINE_HOURS = 1;
